
import Footer from "../components/Footer";
import Header from "../components/Header";
import { LoadingProvider } from "../providers/LoadingProvider";

export default function MainLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main id="main" className="flex-1">
        <LoadingProvider>{children}</LoadingProvider>
      </main>

      <Footer />
    </div>
  );
}
